"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    appBar: {
      position: "relative"
    },
    title: {
      marginLeft: 10,
      flex: 1
    }
  };
});

var FullModal = function FullModal(_ref) {
  var children = _ref.children,
      open = _ref.open,
      handleClose = _ref.handleClose;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_core.Dialog, {
    fullScreen: true,
    open: open,
    onClose: handleClose,
    TransitionComponent: Transition
  }, /*#__PURE__*/React.createElement(_core.AppBar, {
    className: classes.appBar
  }, /*#__PURE__*/React.createElement(_core.Toolbar, null, /*#__PURE__*/React.createElement(_core.IconButton, {
    edge: "start",
    color: "inherit",
    onClick: handleClose,
    "aria-label": "close"
  }, /*#__PURE__*/React.createElement(_Close.default, null)), /*#__PURE__*/React.createElement(_core.Typography, {
    variant: "h6",
    className: classes.title
  }, "Agregar dependencias"))), children);
};

var Transition = /*#__PURE__*/(0, _react.forwardRef)(function Transition(props, ref) {
  return /*#__PURE__*/React.createElement(_core.Slide, _extends({
    direction: "up",
    ref: ref
  }, props));
});
var _default = FullModal;
exports.default = _default;